import React, { ReactNode } from 'react';
import styles from '../../styles.module.css';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';

export default function UserAvatar({
  avatarClass = '',
  colorNumber = 0,
  name = '',
  afterAvatar = null,
  round = false,
  style = {},
  size,
  bg,
}: {
  avatarClass?: string;
  colorNumber?: number;
  name?: string;
  afterAvatar?: ReactNode;
  round?: boolean;
  style?: any;
  size?: string;
  bg?: string;
}) {
  return (
    <span
      className={`${styles.avatar} ${round && styles.round} ${avatarClass}`}
      style={{ background: bg ? bg : avatarBg(colorNumber), width: size, height: size, ...style }}
    >
      {name ? (
        name?.trim().charAt(0)
      ) : (
        <MainIcons.userIcon fill="var(--paper)" className={`${styles.avatarImage}`} />
      )}
      {afterAvatar}
    </span>
  );
}
